/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Description1Inputs */

const he_help_gettingstarted_description1 = /** @type {(inputs: Help_Gettingstarted_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למדו את הבסיס של הגדרת האפליקציה שלכם.`)
};

const en_help_gettingstarted_description1 = /** @type {(inputs: Help_Gettingstarted_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn the basics of setting up your application.`)
};

/**
* | output |
* | --- |
* | "Learn the basics of setting up your application." |
*
* @param {Help_Gettingstarted_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_description1 = /** @type {((inputs?: Help_Gettingstarted_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_description1(inputs)
	return en_help_gettingstarted_description1(inputs)
});
export { help_gettingstarted_description1 as "help_gettingStarted_description" }